import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'react-avatar';
import {
  Button,
  ButtonToolbar,
  ButtonGroup,
} from 'react-bootstrap';
import { Link } from 'react-router';

class BrandInfo extends React.Component {
  render() {
    let brandInfo = this.props.brand
    let contacts = this.props.contacts
    const style = {
      textAlign: "justify",
      border: 2,
    }
    const headStyle ={
      color:"green"
    }
    return (
      <div>
          <div className="row">
            <img src={brandInfo.logo} width="100" height="100" className="col-sm-2 col-md-2"/>
            <div className="col-sm-10 col-md-10">
              <h1>{brandInfo.name}</h1>
              <h4>{brandInfo.tag}</h4>
              <h5> Website :- <a href={brandInfo.website}>{brandInfo.website}</a></h5>
            </div>
          </div><br/>
          <div style={style}>
            <h4 style={headStyle}>Introduction :-</h4>
            {brandInfo.intro?(
              <span><p>{brandInfo.intro}</p><br/></span>
              ):(
              <span><p>The introduction is not available</p><br/></span>)}
          </div><br/>
          {contacts[0]?(
            <div style={style}>
              <h4 style={headStyle}> Group Contact :- </h4>
              <div className="row landing-center">
                  {contacts?(contacts.map((value) =>(
                    <div className="col-sm-4 col-md-4">
                        <h5>{value.brand_manager}</h5>
                        <h5>{value.email}</h5>
                        <h5>{value.phone_number}</h5>
                    </div>
                    ))):('')
                  }
              </div>
              <br/><br/>
            </div>
          ):('')}
          <div style={style}>
            <h4 style={headStyle}> Hotel Document(s) :- </h4>
            {brandInfo.brand_document?(
              <h5><a title="Open in new tab" bsStyle="success" target="_blank" href={brandInfo.brand_document}>Brand Document
              &nbsp;&nbsp;<i className="fa hotel-document-ext-link fa-external-link" aria-hidden="true"></i></a></h5>
              ):(<p> No hotel document(s) available</p>)}
            <br/><br/>
          </div>

          {brandInfo.group_special_offers?(
            <div style={style}>
              <h4 style={headStyle}>Group Special Offers :-</h4>
              <p>{brandInfo.group_special_offers}</p><br/><br/>
            </div>
            ):('')}
          
          {brandInfo.Entertainment_group_benefits?(
            <div style={style}>
              <h4 style={headStyle}>Entertainment Group Benefits :-</h4>
              <p>{brandInfo.Entertainment_group_benefits}</p><br/><br/>
            </div>
            ):('')}

          {brandInfo.Entertainment_group_practices?(
            <div style={style}>
              <h4 style={headStyle}>Entertainment Group Practices :-</h4>
              <p>{brandInfo.Entertainment_group_practices}</p><br/><br/>
            </div>
          ):('')}
      </div>
      );
  }
}

export default BrandInfo;


// WEBPACK FOOTER //
// src/routes/home/components/BrandInfo.js